// Player states
export const STATE_NOT_READY = 'notready';
export const STATE_EMPTY = 'empty';
export const STATE_IDLE = 'idle';
export const STATE_LOADING = 'loading';
export const STATE_PAUSED = 'paused';
export const STATE_PLAYING = 'playing';
export const STATE_WAITING = 'waiting';
export const STATE_ERROR = 'error';
export const STATE_ADPLAYING = 'adplaying';

// Playback events
export const EVENT_ERROR = 'error';
export const EVENT_LOAD = 'load';
export const EVENT_PLAY = 'play';
export const EVENT_FIRST_PLAY = 'firstPlay';
export const EVENT_RESUME = 'resume';
export const EVENT_PAUSE = 'pause';
export const EVENT_PLAYING = 'playing';
export const EVENT_POSITION = 'timeupdate';
export const EVENT_LOADING = 'loading';
export const EVENT_LOADED = 'loaded';
export const EVENT_LOADED_METADATA = 'loadedmetadata';
export const EVENT_LOADED_DATA = 'loadeddata';
export const EVENT_VOLUME_CHANGE = 'volumechange';
export const EVENT_MUTE = 'mute';
export const EVENT_UNMUTE = 'unmute';
export const EVENT_CANPLAY = 'canplay';
export const EVENT_STOP = 'stop';
export const EVENT_UNLOAD = 'unload';
export const EVENT_DURATION_CHANGE = 'durationchange';
export const EVENT_PROGRESS = 'progress';
export const EVENT_BUFFERING = 'buffering';
export const EVENT_WAITING = 'waiting';
export const EVENT_COMPLETE = 'ended';
export const EVENT_SEEK = 'seeking';
export const EVENT_SEEKED = 'seeked';
export const EVENT_SEEKABLE = 'seekable';
export const EVENT_STALLED = 'stalled';
export const EVENT_PLAYBACK_RATE_CHANGE = 'ratechange';
export const EVENT_STATE = 'state';
export const EVENT_READY = 'ready';
export const EVENT_DESTROY = 'destroy';
export const EVENT_SOURCE_CHANGE = 'sourcechange';
export const EVENT_LOAD_START = 'loadstart';
export const EVENT_REPEAT_CHANGE = 'repeatchange';
export const EVENT_LANGUAGE_CHANGE = 'languagechange';
export const EVENT_LANGUAGES_CHANGE = 'languageschange';
export const EVENT_EMPTY = 'empty';
export const EVENT_BEFORE_PLAY = 'beforeplay';
export const EVENT_PAUSED = 'paused';
export const EVENT_DOWNLOAD = 'download';

// Playlist events
export const EVENT_PLAYLIST_LOAD = 'playlistload';
export const EVENT_PLAYLIST_CHANGE = 'playlistchange';
export const EVENT_PLAYLIST_ITEM_CHANGE = 'playlistselect';
export const EVENT_PLAYLIST_COMPLETE = 'playlistcomplete';
export const EVENT_PLAYLIST_UPDATE = 'playlistupdate';
export const EVENT_PLAYLIST_ADD = 'playlistadd';
export const EVENT_PLAYLIST_ADDED = 'playlistadded';

export const REPEAT_MODE_NONE = 'none';
export const REPEAT_MODE_SINGLE = 'single';
export const REPEAT_MODE_PLAYLIST = 'playlist';

// Quality events
export const EVENT_LEVEL_CHANGE = 'levelchange';
export const EVENT_LEVELS_CHANGE = 'levelschange';

// Metadata events
export const EVENT_METADATA_CHANGE = 'metadatachange';

// Advertising states
export const STATE_BEFORE_PREROLL = 'BeforePreRoll';
export const STATE_CONTENT_PLAYING = 'ContentPlaying';
export const STATE_AD_PLAYING = 'AdPlaying';

// Advertising events
export const EVENT_AD_PLAY = 'adplay';
export const EVENT_AD_SKIP = 'adskip';
export const EVENT_AD_COMPLETE = 'adcomplete';
export const EVENT_AD_BREAK_START = 'adbreakstart';
export const EVENT_AD_BREAK_END = 'adbreakend';
export const EVENT_AD_START = 'adstart';
export const EVENT_AD_END = 'adend';
export const EVENT_AD_SKIPPABLE = 'adskippable';
export const EVENT_AD_COMPANION_START = 'adcompanionstart';
export const EVENT_AD_COMPANION_END = 'adcompanionend';

// Text track events
export const EVENT_CUE_CHANGE = 'textcuechange';
export const EVENT_TRACK_ADD = 'texttrackadd';
export const EVENT_TRACK_REMOVE = 'texttrackremove';
export const EVENT_TRACKS_CHANGE = 'texttrackschange';
export const EVENT_TRACK_CHANGE = 'texttrackchange';
export const EVENT_TRACK_LOAD = 'texttrackload';

// Tracking events
export const EVENT_TRACKING = 'tracking';
export const EVENT_TRACKING_POSITION = 'position';
export const EVENT_TRACKING_ACTION = 'action';
export const EVENT_TRACKING_ACTION_START = 'start';
export const EVENT_TRACKING_ACTION_COMPLETE = 'complete';
export const EVENT_TRACKING_ACTION_PROGRESS = 'progress';
export const EVENT_TRACKING_ACTION_PAUSE = 'pause';
export const EVENT_TRACKING_ACTION_RESUME = 'resume';
export const EVENT_TRACKING_ACTION_MUTE = 'mute';
export const EVENT_TRACKING_ACTION_UNMUTE = 'unmute';
export const EVENT_TRACKING_ACTION_SEEK = 'seek';
export const EVENT_TRACKING_ACTION_ADSKIP = 'adskip';
export const EVENT_TRACKING_ACTION_DOWNLOAD = 'download';

// Now Playing events
export const EVENT_NOWPLAYING_CHANGE = 'nowplayingchange';

// Error codes
export const ERR_ABORTED = 1;
export const ERR_NETWORK = 2;
export const ERR_DECODE = 3;
export const ERR_SRC_NOT_SUPPORTED = 4;
export const ERR_SRC_INVALID = 5;
export const ERR_NO_PLAYABLE_SOURCES = 6;
export const ERR_UNKNOWN = 7;
export const ERR_PLAYLIST = 8;

// Error messages
export const ERR_ABORTED_MSG = 'The fetching of the associated resource was aborted at the user\'s request.';
export const ERR_NOT_SUPPORTED_MSG = 'Playback not supported on this device.';
export const ERR_SRC_NOT_SUPPORTED_MSG = 'Source not supported.';
export const ERR_DECODE_MSG = 'Source could not be decoded.';
export const ERR_NETWORK_MSG = 'Unable to access source, the network may be down or the source no longer exists.';
export const ERR_UNKNOWN_MSG = 'An unknown error ocurred.';
export const ERR_PLAYLIST_LOAD_MSG = 'Failed to load playlist.';
export const ERR_SRC_INVALID_MSG = 'Invalid playlist source.';
export const ERR_NO_PLAYABLE_SOURCES_MSG = 'No playable sources.';

// Metadata types
export const METADATA_TYPE_AD_SERVER = 'ad-server';
export const METADATA_TYPE_AD_CLIENT = 'ad-client';
export const METADATA_TYPE_AD_VAST = 'ad-vast';
export const METADATA_TYPE_PODCAST = 'podcast';
export const METADATA_TYPE_STREAM = 'stream';
export const METADATA_TYPE_METADATA = 'metadata';
export const METADATA_TYPE_NOWPLAYING = 'nowplaying';
export const METADATA_TYPE_PLAYLIST = 'playlist';

// AdsWizz metadata types
export const METADATA_TYPE_ADSWIZZ_STREAM = 'adswizz-stream';
export const METADATA_TYPE_ADSWIZZ_PODCAST = 'adswizz-podcast';
export const METADATA_TYPE_ADSWIZZ_AD = 'adswizz-ad';

// Link types
export const LINK_TYPE_LIKE = 'like';
export const LINK_TYPE_NOWPLAYING = 'nowplaying';
export const LINK_TYPE_WAVEFORM = 'waveform';

// Formats
export const FORMAT_MP4 = 'mp4';
export const FORMAT_M4A = 'm4a';
export const FORMAT_MP3 = 'mp3';
export const FORMAT_AAC = 'aac';
export const FORMAT_OGA = 'oga';
export const FORMAT_OGG = 'ogg';
export const FORMAT_WEBM = 'webm';
export const FORMAT_OPUS = 'opus';
export const FORMAT_M3U8 = 'm3u8';
export const FORMAT_ADTS = 'adts';
export const FORMAT_TS = 'ts';

// Format mime types
export const FORMAT_MPEG4_MIME = 'audio/mp4';
export const FORMAT_MPEG_MIME = 'audio/mpeg';
export const FORMAT_MP3_MIME = 'audio/mp3';
export const FORMAT_AAC_MIME = 'audio/aac';
export const FORMAT_M3U8_MIME = 'application/x-mpegURL';
export const FORMAT_M3U8_ALT_MIME = 'application/vnd.apple.mpegurl';
export const FORMAT_MPEG4_AAC_LC_MIME = 'audio/mp4; codecs="mp4a.40.2"'; // Low Complexity AAC in MP4
export const FORMAT_MPEG4_AAC_SBR_MIME = 'audio/mp4; codecs="mp4a.40.5"'; // High Efficiency AAC in MP4
export const FORMAT_MPEG4_AAC_PS_MIME = 'audio/mp4; codecs="mp4a.40.29"'; // High Efficiency v2 AAC in MP4
export const FORMAT_ADTS_MIME = 'video/MP2T';
export const FORMAT_OGA_MIME = 'audio/ogg; codecs="vorbis"';
export const FORMAT_WEBM_MIME = 'audio/webm; codecs="vorbis"';
export const FORMAT_OPUS_MIME = 'audio/ogg; codecs="opus"';

// Playback formats supported
export const FORMAT_TYPES = {
  [FORMAT_MP4]: [FORMAT_MPEG4_MIME, FORMAT_MPEG4_AAC_LC_MIME, FORMAT_MPEG4_AAC_SBR_MIME, FORMAT_MPEG4_AAC_PS_MIME],
  [FORMAT_M4A]: [FORMAT_MPEG4_MIME, FORMAT_MPEG4_AAC_LC_MIME, FORMAT_MPEG4_AAC_SBR_MIME, FORMAT_MPEG4_AAC_PS_MIME],
  [FORMAT_M3U8]: [FORMAT_M3U8_MIME, FORMAT_M3U8_ALT_MIME],
  [FORMAT_MP3]: [FORMAT_MPEG_MIME, FORMAT_MP3_MIME],
  [FORMAT_AAC]: [FORMAT_AAC_MIME],
  [FORMAT_ADTS]: [FORMAT_ADTS_MIME],
  [FORMAT_TS]: [FORMAT_ADTS_MIME],
  [FORMAT_OGA]: [FORMAT_OGA_MIME],
  [FORMAT_OGG]: [FORMAT_OGA_MIME],
  [FORMAT_WEBM]: [FORMAT_WEBM_MIME],
  [FORMAT_OPUS]: [FORMAT_OPUS_MIME]
};

// Media file extensions
export const MEDIA_EXTENSIONS = [
  FORMAT_MP4,
  FORMAT_M4A,
  FORMAT_MP3,
  FORMAT_AAC,
  FORMAT_OGA,
  FORMAT_OGG,
  FORMAT_WEBM,
  FORMAT_OPUS,
  FORMAT_M3U8,
  FORMAT_ADTS,
  FORMAT_TS
];

// Empty source url
export const EMPTY_SOURCE = 'about:blank';

// URL to HLS.js library
export const HLSJS_URL = 'https://cdn.jsdelivr.net/npm/hls.js@latest';

// Qualities
export const QUALITY_LOW = 'low';
export const QUALITY_MEDIUM = 'medium';
export const QUALITY_HIGH = 'high';

// Loader timeouts
export const LOAD_TIMEOUT = 30000;
export const LOAD_REQUEST_TIMEOUT = 30000;

// Compile-time constants
export const AD_REQUEST_URL = __AD_REQUEST_URL__; /* eslint-disable-line */
export const VERSION = __VERSION__; /* eslint-disable-line */
export const ENVIRONMENT = __ENVIRONMENT__; /* eslint-disable-line */
export const DEBUG = __DEBUG__; /* eslint-disable-line */
export const LOG_LEVEL = __LOG_LEVEL__; /* eslint-disable-line */
export const ARTWORK_API_URL = __ARTWORK_API_URL__; /* eslint-disable-line */
export const SEND_CONTENT_EVENTS = __SEND_CONTENT_EVENTS__; /* eslint-disable-line */
